import Navbar from 'components/navbar'
import Footer from 'components/footer'
import AboutUsData from 'constants/aboutUsData'
import Link from 'next/link'
import teamData from 'constants/teamData'
import Head from 'next/head'

const AboutUs = () => {
  return (
    <>
      <Head>
        <meta name="title" content="Know about us - Kahanchale" />
        <meta property="og:title" content="About Us | The story behind creating Kahan Chale" />
        <meta property="twitter:author" content="Kahan Chale" />
        <meta property="twitter:title" content="About Us | The story behind creating Kahan Chale" />
        <meta
          property="og:description"
          content="Kahan Chale is an AI engine which helps you find the best travel places in India. Read our story to find out how the Kahan Chale started and begin your travel planning with us."
        />
        <meta
          property="twitter:description"
          content="Kahan Chale is an AI engine which helps you find the best travel places in India. Read our story to find out how the Kahan Chale started and begin your travel planning with us."
        />
        <meta
          property="twitter:image:src"
          name="twitter:image:src"
          content="https://kahanchale.com/images/og-image1.jpeg"
        />
        <meta
          property="description"
          name="description"
          content="Kahan Chale is an AI engine which helps you find the best travel places in India. Read our story to find out how the Kahan Chale started and begin your travel planning with us."
        />
        <meta property="og:type" content="article" />
        <meta property="og:image" content="https://kahanchale.com/images/og-image1.jpeg" />
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:image" content="https://kahanchale.com/images/og-image1.jpeg" />
        <meta property="twitter:url" ontent="https://kahanchale.com/about-us/" />
        <meta property="og:url" content="https://kahanchale.com/about-us/" />
      </Head>
      <Navbar />
      <div className="bg-about bg-no-repeat bg-cover md:pt-24 pb-20 md:p-24 pt-20 p-8 bg-top-5">
        <div className="flex flex-col items-center justify-center md:mx-36 mx-0">
          <div className="py-20 text-center w-full">
            <h1 className="md:text-6xl text-3xl uppercase text-white font-medium">About Us</h1>
          </div>
          <div className="flex flex-col items-start bg-blue-50 justify-start md:px-12 px-6 md:text-lg text-sm py-8 w-full rounded-xl text-justify">
            <p className="py-2">
              It all started when my sister came to me asking where should she travel with her friends as no one was
              able to decide. Although I suggested her a few places but her friends didn’t like the place and eventually
              the trip never happened. That day I decided to make sure that no group should cancel their trip because of
              not finding a good travel location.
            </p>
            <p className="py-2">
              Being an avid traveler, even I had this problem of deciding where to travel every time when I decided to
              go on a trip. The usual solutions to explore places are either commission biased recommendations to
              crowded touristic destinations or going through plethora of online blogs to find one ideal location. Both
              of them are not very effective. So we started working on the solution named{' '}
              <span className="font-extrabold md:text-lg text-base">Kahan Chale </span>
              which means Where should we travel?
            </p>
            <p className="py-2">
              We believe that every individual has different preferences when it comes to traveling and they should be
              able to find a destination which is tailored according to their individual choices. We are doing doing
              exactly that!
            </p>
            <p className="py-2">Through Kahan Chale, we are also contributing to the society in numerous ways:</p>
            <p className="py-2 px-5">
              <ol className="list-decimal">
                {AboutUsData.map((data, index) => (
                  <li className="py-1" key={index}>
                    <span className="font-extrabold">{data.heading}</span>
                    {data.text}
                  </li>
                ))}
              </ol>
            </p>
            <div className="flex flex-col items-center justify-center">
              <div className="pt-8">
                <h3 className="md:text-2xl text-lg text-center font-semibold" style={{ wordSpacing: '.25rem' }}>
                  Do try out Kahan Chale and let us know if you like the recommendations
                </h3>
              </div>
              <Link href="/quiz">
                <span className="bg-themeOrange p-2 my-6 rounded-xl text-white font-medium">Find your Destination</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white p-10">
        <div className="flex flex-col mb-16 items-center justify-center w-full">
          <h1 className="md:text-5xl text-3xl font-medium">Our Team</h1>
        </div>
        <div className="grid md:grid-cols-2 gap-20 max-w-full lg:mx-20 md:mx-10 my-8">
          {teamData.map((detail, index) => (
            <div key={index} className="p-4 flex flex-col items-center justify-center">
              <div className="p-4 rounded-full">
                <img src={detail.image} className="rounded-full max-w-none md:w-52 w-32 md:h-52 h-32" />
              </div>
              <div className="p-2 text-center">
                <h4 className="text-3xl p-1">{detail.name}</h4>
                <h4 className="text-3xl italic p-1 text-themeOrange">{detail.position}</h4>
                <div className="flex flex-row items-center justify-center">
                  <a className="w-8 h-8 m-2" target="_blank" href={detail.social.linkedin}>
                    <img src="/images/linkedin.png" />
                  </a>
                  <a className="w-8 h-8 m-2" target="_blank" href={detail.social.facebook}>
                    <img src="/images/facebook.png" />
                  </a>
                  <a className="w-8 h-8 m-2" target="_blank" href={detail.social.instagram}>
                    <img src="/images/instagram.png" />
                  </a>
                  <a className="w-8 h-8 m-2" target="_blank" href={detail.social.twitter}>
                    <img src="/images/twitter.png" />
                  </a>
                </div>
                <p className="lg:px-16 px-4 py-4 text-lg text-center">{detail.about}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </>
  )
}

export default AboutUs
